import React from "react";

import CommonButton from "../../Button";
import clsx from "clsx";

type Props = { contactInfo?: string; contactNumber?: string };

export default function HistoryContactInfo({
  contactInfo,
  contactNumber,
}: Props) {
  const getByteLength = (s: string) => {
    return s
      .split("")
      .map((c) => c.charCodeAt(0))
      .reduce((acc, cur) => (cur < 128 ? acc + 1 : acc + 2), 0);
  };

  return (
    <div className="flex gap-2.5 justify-between items-center">
      <div className="flex flex-col">
        <div className=" break-all">{contactInfo}</div>
        {/* <div className="text-xs text-brand-neutral-30">
                {rentDetail?.createdByCompany}
              </div> */}
      </div>
      <a href={`tel:${contactNumber}`}>
        <CommonButton
          variant="tertiary"
          className={clsx([
            "text-sm text-brand-neutral-60 px-4 py-[11px] min-w-[62px] max-h-[45px] rounded-[3px] border-brand-gray-20",
            {
              "whitespace-nowrap": getByteLength(contactInfo ?? "") <= 18,
              "whitespace-pre-line": getByteLength(contactInfo ?? "") > 18,
            },
          ])}
        >
          {getByteLength(contactInfo ?? "") <= 18 ? "전화 연결" : "전화\n연결"}
        </CommonButton>
      </a>
    </div>
  );
}
